// Minimal product card controller. One delegated listener drives every card on the page.
(function () {
  function images(media) {
    try { return JSON.parse(media.getAttribute('data-imgs')) || []; } catch (e) { return []; }
  }

  // Swap the visible image, including any <picture> sources that would
  // otherwise take precedence over img.src.
  function setImgUrl(img, url) {
    img.src = url;
    img.srcset = url;
    var pic = img.parentElement;
    if (pic && pic.tagName === 'PICTURE') {
      pic.querySelectorAll('source').forEach(function (s) { s.srcset = url; });
    }
  }


  function setImage(media, i) {
    var list = images(media);
    if (i < 0 || i >= list.length) return;
    if ((parseInt(media.getAttribute('data-idx'), 10) || 0) === i) return;
    var img = media.querySelector('.tc-card__img');
    if (!img) return;
    media.setAttribute('data-idx', i);
    var pre = new Image();
    pre.onload = function () { setImgUrl(img, list[i]); };
    pre.src = list[i];
  }

  function step(media, dir) {
    var list = images(media);
    if (list.length < 2) return;
    setImage(media, ((parseInt(media.getAttribute('data-idx'), 10) || 0) + dir + list.length) % list.length);
  }

  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest) return;
      var m = e.target.closest('.tc-card__media');
      if (m && !(e.relatedTarget && m.contains(e.relatedTarget))) setImage(m, 1);
    });
    document.addEventListener('mouseout', function (e) {
      if (!e.target.closest) return;
      var m = e.target.closest('.tc-card__media');
      if (m && !(e.relatedTarget && m.contains(e.relatedTarget))) setImage(m, 0);
    });


    // Only warm hover images for cards near the viewport, not the whole catalogue.
    if ('IntersectionObserver' in window) {
      var hoverObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hoverObserver.unobserve(entry.target);
          var list = images(entry.target);
          if (list[1]) { var im = new Image(); im.fetchPriority = 'low'; im.src = list[1]; }
        });
      }, { rootMargin: '160px 0px' });
      document.querySelectorAll('.tc-card__media').forEach(function (media) { hoverObserver.observe(media); });
    }

  }

  // Badge cycling. This used to re-query the whole document every 2.5s and
  // toggle a class on every card on the page, on every page, forever — which
  // cost more main-thread time than everything else in the theme combined.
  // Now the groups are collected once, the timer never starts when there is
  // nothing to cycle, and only on-screen groups in a visible tab are touched.
  (function cycleBadges() {
    var groups = [];
    document.querySelectorAll('.tc-card__badge[data-cycle]').forEach(function (el) {
      var txts = el.querySelectorAll('.tc-card__badge-txt');
      if (txts.length > 1) groups.push({ el: el, txts: txts, i: 0 });
    });
    if (!groups.length) return;

    var visible = groups;
    if ('IntersectionObserver' in window) {
      var onScreen = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) onScreen.add(e.target); else onScreen.delete(e.target);
        });
        visible = groups.filter(function (g) { return onScreen.has(g.el); });
      });
      groups.forEach(function (g) { io.observe(g.el); });
      visible = [];
    }

    var timer = null;
    function tick() {
      for (var n = 0; n < visible.length; n++) {
        var g = visible[n];
        g.txts[g.i].classList.remove('is-active');
        g.i = (g.i + 1) % g.txts.length;
        g.txts[g.i].classList.add('is-active');
      }
    }
    function start() { if (!timer) timer = setInterval(tick, 2500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    if (!document.hidden) start();
  })();

  var sx = 0, sy = 0;
  document.addEventListener('touchstart', function (e) {
    var m = e.target.closest && e.target.closest('.tc-card__media');
    if (!m) return;
    var t = e.changedTouches[0];
    sx = t.clientX; sy = t.clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var m = e.target.closest && e.target.closest('.tc-card__media');
    if (!m) return;
    var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { e.preventDefault(); step(m, dx < 0 ? 1 : -1); }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var arrow = e.target.closest('.tc-card__arrow');
    if (arrow) {
      e.preventDefault(); e.stopPropagation();
      step(arrow.closest('.tc-card__media'), arrow.getAttribute('data-dir') === 'next' ? 1 : -1);
      return;
    }

    var sw = e.target.closest('.tc-card__swatch');
    if (sw) {
      e.preventDefault();
      switchColor(sw);
      return;
    }

    var btn = e.target.closest('.tc-card__add');
    if (btn) {
      e.preventDefault();
      if (btn.classList.contains('tc-card__add--soldout')) {
        var u = btn.getAttribute('data-url');
        if (u) window.location.href = u;
        return;
      }
      if (offerVipChoice(btn)) return;
      add(btn.closest('.tc-card'), btn.getAttribute('data-variant-id'), btn.getAttribute('data-variant-title'));
      return;
    }
  });

  // Swap the card in place to the chosen colour product (no navigation).
  function switchColor(sw) {
    var card = sw.closest('.tc-card');
    if (!card) return;
    var d = sw.dataset;
    var swatches = card.querySelectorAll('.tc-card__swatch');
    for (var i = 0; i < swatches.length; i++) swatches[i].classList.remove('is-active');
    sw.classList.add('is-active');

    var media = card.querySelector('.tc-card__media');
    var img = media && media.querySelector('.tc-card__img');
    if (img && d.imgs) {
      media.setAttribute('data-imgs', d.imgs);
      media.setAttribute('data-idx', '0');
      var first;
      try { first = (JSON.parse(d.imgs) || [])[0]; } catch (e) { first = null; }
      if (first) { var pre = new Image(); pre.onload = function () { setImgUrl(img, first); }; pre.src = first; }
      if (d.title) img.alt = d.title;
    }

    var mediaLink = media && media.querySelector('.product-image-container');
    if (mediaLink && d.url) mediaLink.setAttribute('href', d.url);
    var titleLink = card.querySelector('.tc-card__title a');
    if (titleLink) {
      var titleTxt = titleLink.querySelector('.tc-card__title-txt');
      if (d.title) { if (titleTxt) titleTxt.textContent = d.title; else titleLink.textContent = d.title; }
      if (d.url) titleLink.setAttribute('href', d.url);
    }
    if (d.title) card.setAttribute('data-title', d.title);

    var now = card.querySelector('.tc-card__price-now');
    var was = card.querySelector('.tc-card__price--was');
    if (now && d.price) { now.textContent = d.price; now.classList.toggle('tc-card__price--sale', !!d.compare); }
    if (was) {
      if (d.compare) { was.textContent = d.compare; was.hidden = false; }
      else { was.textContent = ''; was.hidden = true; }
    }

    var add_btn = card.querySelector('.tc-card__add');
    if (add_btn) {
      add_btn.classList.toggle('tc-card__add--soldout', d.available !== 'true');
      if (d.variantId) add_btn.setAttribute('data-variant-id', d.variantId);
      add_btn.setAttribute('data-variant-title', d.variantTitle || '');
      if (d.url) add_btn.setAttribute('data-url', d.url);
    }

    var variantLabel = card.querySelector('.tc-card__variant');
    if (variantLabel) {
      if (d.variantTitle) { variantLabel.textContent = ' – ' + d.variantTitle; variantLabel.hidden = false; }
      else { variantLabel.textContent = ''; variantLabel.hidden = true; }
    }
  }

  /*
   * The same choice the PDP puts in the buy box, on the card: pay the member
   * price by joining, or pay the list price. Only where there is a choice to
   * make -- the product carries a member price, the shopper is not already a
   * member, and the membership is not in the cart, in which case the price is
   * already theirs and the button just adds.
   */
  var vipModal = null;

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return String(Shopify.formatMoney(cents)).replace(/<[^>]*>/g, '');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* Phone: a sheet off the bottom, which is where a thumb is. Desktop: the
     choice stays inside the card that was clicked, so the page behind it is
     never covered and the shopper does not lose their place in the grid. */
  function isPhone() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function buildVipModal() {
    if (vipModal) return vipModal;
    var el = document.createElement('div');
    el.className = 'tcvip';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="tcvip__scrim" data-tcvip-close></div>' +
      '<div class="tcvip__panel" role="dialog" aria-modal="true" aria-labelledby="tcvip-title">' +
        '<button type="button" class="tcvip__x" data-tcvip-close aria-label="Close">&times;</button>' +
        '<span class="tcvip__grip" aria-hidden="true"></span>' +
        '<div class="tcvip__head">' +
          '<img class="tcvip__thumb" alt="" data-tcvip-thumb>' +
          '<div class="tcvip__id">' +
            '<p class="tcvip__title" id="tcvip-title"></p>' +
            '<span class="tcvip__rating" data-tcvip-rating></span>' +
            '<p class="tcvip__price"><span data-tcvip-now></span><s data-tcvip-was></s></p>' +
          '</div>' +
        '</div>' +
        '<p class="tcvip__eyebrow">Choose how you buy</p>' +
        '<button type="button" class="tcvip__opt tcvip__opt--vip" data-tcvip-join>' +
          '<span class="tcvip__opt-main">' +
            '<span class="tcvip__opt-name"><span class="tcvip__chip">Carry Club</span>Become a member</span>' +
            '<span class="tcvip__opt-note" data-tcvip-note></span>' +
          '</span>' +
          '<span class="tcvip__opt-price" data-tcvip-member></span>' +
        '</button>' +
        '<button type="button" class="tcvip__opt" data-tcvip-full>' +
          '<span class="tcvip__opt-main">' +
            '<span class="tcvip__opt-name">Buy without membership</span>' +
            '<span class="tcvip__opt-note">No membership</span>' +
          '</span>' +
          '<span class="tcvip__opt-price" data-tcvip-fullprice></span>' +
        '</button>' +
      '</div>';
    document.body.appendChild(el);
    vipModal = el;

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-tcvip-close]')) { closeVip(); return; }
      var join = e.target.closest('[data-tcvip-join]');
      var full = e.target.closest('[data-tcvip-full]');
      if (!join && !full) return;
      var card = el._card;
      var btn = el._btn;
      closeVip();
      if (!card || !btn) return;
      add(card, btn.getAttribute('data-variant-id'), btn.getAttribute('data-variant-title'), join ? btn : null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && vipModal && !vipModal.hasAttribute('hidden')) closeVip();
    });
    /* An in-card panel is inside the grid, so a click anywhere else closes it
       the way leaving a menu does. */
    document.addEventListener('click', function (e) {
      if (!vipModal || vipModal.hasAttribute('hidden')) return;
      if (!vipModal.classList.contains('tcvip--incard')) return;
      if (e.target.closest('.tcvip__panel') || e.target.closest('.tc-card__add')) return;
      closeVip();
    }, true);
    return el;
  }

  function closeVip() {
    if (!vipModal) return;
    vipModal.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    if (vipModal.parentNode !== document.body) document.body.appendChild(vipModal);
  }

  function membershipInCart() {
    var cart = window.ToteCart && window.ToteCart.cart;
    if (!cart || !cart.items) return false;
    return cart.items.some(function (i) { return !!i.selling_plan_allocation; });
  }

  function offerVipChoice(btn) {
    var member = parseInt(btn.getAttribute('data-member-price'), 10) || 0;
    var full = parseInt(btn.getAttribute('data-full-price'), 10) || 0;
    if (!member || !full || full <= member) return false;
    if (!btn.getAttribute('data-vip-variant')) return false;
    if (membershipInCart()) return false;

    var card = btn.closest('.tc-card');
    var el = buildVipModal();
    el._card = card;
    el._btn = btn;

    var img = card && card.querySelector('.tc-card__img');
    var thumb = el.querySelector('[data-tcvip-thumb]');
    if (thumb) {
      var src = img && (img.currentSrc || img.src);
      thumb.src = src || '';
      thumb.hidden = !src;
    }
    el.querySelector('.tcvip__title').textContent = btn.getAttribute('data-product-title') || '';

    var rating = card && card.querySelector('.tc-card__rating');
    var ratingBox = el.querySelector('[data-tcvip-rating]');
    if (ratingBox) {
      ratingBox.innerHTML = rating ? rating.innerHTML : '';
      ratingBox.hidden = !rating;
    }

    var nowEl = el.querySelector('[data-tcvip-now]');
    var wasEl = el.querySelector('[data-tcvip-was]');
    var cardWas = card && card.querySelector('.tc-card__price--was');
    if (nowEl) nowEl.textContent = money(full);
    if (wasEl) {
      var wasTxt = cardWas && !cardWas.hidden ? cardWas.textContent.trim() : '';
      wasEl.textContent = wasTxt;
      wasEl.hidden = !wasTxt;
    }

    el.querySelector('[data-tcvip-member]').textContent = money(member);
    el.querySelector('[data-tcvip-fullprice]').textContent = money(full);
    var plan = parseInt(btn.getAttribute('data-vip-price'), 10) || 0;
    el.querySelector('[data-tcvip-note]').textContent =
      'Save ' + money(full - member) + ' today \u00b7 ' + money(plan) + '/year';

    var phone = isPhone();
    el.classList.toggle('tcvip--sheet', phone);
    el.classList.toggle('tcvip--incard', !phone);
    if (phone) {
      if (el.parentNode !== document.body) document.body.appendChild(el);
      document.documentElement.style.overflow = 'hidden';
    } else if (card) {
      card.appendChild(el);
      document.documentElement.style.overflow = '';
    }

    el.removeAttribute('hidden');
    var first = el.querySelector('[data-tcvip-join]');
    if (first) first.focus({ preventScroll: true });
    return true;
  }

  function add(card, variantId, variantTitle, joinBtn) {
    if (!card || !variantId) return;
    var btn = card.querySelector('.tc-card__add');
    if (!btn || btn.dataset.loading) return;
    btn.dataset.loading = '1';
    btn.classList.add('is-loading');
    var img = card.querySelector('.tc-card__img');
    var src = img && (img.currentSrc || img.src);

    var lines = [{ id: variantId, quantity: 1 }];
    if (joinBtn) {
      var vipId = parseInt(joinBtn.getAttribute('data-vip-variant'), 10) || 0;
      var vipPlan = parseInt(joinBtn.getAttribute('data-vip-plan'), 10) || 0;
      if (vipId) {
        var vipLine = { id: vipId, quantity: 1 };
        if (vipPlan) vipLine.selling_plan = vipPlan;
        lines.push(vipLine);
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: lines })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        reset();
        if (!res.ok) return;
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        if (window.triggerCartFlyAnimation && img) window.triggerCartFlyAnimation(btn, src);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: {
          title: card.getAttribute('data-title'),
          image: src,
          variant: variantTitle || ''
        } } }));
        if (window.openCartDrawer) window.openCartDrawer();
      })
      .catch(reset);

    function reset() {
      btn.classList.remove('is-loading');
      delete btn.dataset.loading;
    }
  }
})();
